import { PestKind } from "@/services/backend/qpm/pests/types/pest-enum";

export class PestKindUtil {
  private static descriptions: { [key in PestKind]: string } = {
    [PestKind.Category]: "Schädlingskategorie",
    [PestKind.Indicator]: "Indikator für Schädlinge",
  };

  private static abbreviations: { [key in PestKind]: string } = {
    [PestKind.Category]: "Kategorie",
    [PestKind.Indicator]: "Indikator",
  };

  static toString(type: PestKind): string {
    return this.abbreviations[type];
  }

  static toLongString(type: PestKind): string {
    return this.descriptions[type] || "Unknown";
  }
}
